import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import { Layout, Menu, Icon, Spin } from "antd";

import * as authService from "./services/authService";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/Login";

import ReportPage from "./pages/ReportPage";
import ReportHashPage from "./pages/ReportHashPage";
import ResultsPage from "./pages/ResultsPage";
import MyResultsPage from "./pages/MyResultsPage";
import SubmitPage from "./pages/SubmitPage";
import Account from "./components/Home.jsx";
import HomePage from "./pages/HomePage";
import BriefReportPage from "./pages/BriefReportPage";
import SearchPage from "./pages/SearchPage";

import "./App.css";
import logo from "./ELFDIGEST.png";

const { Sider } = Layout;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      loading: true,
    };
  }

  componentDidMount() {
    this.checkAuth();
  }

  checkAuth = async () => {
    try {
      const user = await authService.getCurrentUser();
      this.setState({ user, loading: false });
    } catch (err) {
      this.setState({ user: null, loading: false });
    }
  };

  handleLogin = (user) => {
    this.setState({ user });
  };

  handleLogout = async () => {
    await authService.logout();
    this.setState({ user: null });
  };

  render() {
    const { user, loading } = this.state;

    if (loading) {
      return (
        <div style={{ textAlign: "center", marginTop: 100 }}>
          <Spin size="large" />
        </div>
      );
    }

    return (
      <Router>
        <Sider id="sider">
          <img src={logo} className="logo" alt="ELFDIGEST" />
          <Menu theme="light" mode="inline">
            <Menu.Item key="1">
              <Icon type="cloud" />
              <span className="nav-text">Public Reports</span>
              <Link to="/results" />
            </Menu.Item>
            <Menu.Item key="6">
              <Icon type="cloud" />
              <span className="nav-text">My Reports</span>
              <Link to="/myreports" />
            </Menu.Item>
            <Menu.Item key="2">
              <Icon type="upload" />
              <span className="nav-text">Submit</span>
              <Link to="/submit" />
            </Menu.Item>
            <Menu.Item key="3">
              <Icon type="search" />
              <span className="nav-text">Search</span>
              <Link to="/search" />
            </Menu.Item>
            <Menu.Item key="4">
              <Icon type="user" />
              <span className="nav-text">Account</span>
              <Link to="/account" />
            </Menu.Item>
            <Menu.Item key="5">
              <Icon type="bulb" />
              <span className="nav-text">About</span>
              <Link to="/about" />
            </Menu.Item>
          </Menu>
        </Sider>

        <div id="main-content">
          <Switch>
            <Route exact={true} path="/" component={HomePage} />
            <Route path="/about" component={HomePage} />
            <Route
              path="/login"
              render={props => (
                <Login {...props} user={user} onLogin={this.handleLogin} />
              )}
            />
            <ProtectedRoute path="/results" component={ResultsPage} user={user} />
            <ProtectedRoute path="/myreports" component={MyResultsPage} user={user} onLogout={this.handleLogout} />
            <Route path="/failed" component={HomePage} />
            <Route path="/pending" component={HomePage} />
            <ProtectedRoute path="/result/:id" component={ReportPage} user={user} />
            <ProtectedRoute path="/submit" component={SubmitPage} user={user} />
            <ProtectedRoute path="/report/:id" component={ReportHashPage} user={user} />
            <ProtectedRoute path="/account" component={Account} user={user} onLogout={this.handleLogout} />
            <Route path="/brief/:id" component={BriefReportPage} />
            <Route path="/search" component={SearchPage} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
